// #region Imports
import React, { useState, useEffect, useRef, useCallback } from 'react';
import './ServicoCrud.scss';
// #endregion

export default function ServicoCrud({ open = false, servico = null, onClose = () => {}, onSave = () => {} }) {
  // #region Estado form
  const [form, setForm] = useState({ nome: '', categoria: '', descricao: '', preco_padrao: 0, perc_comissao_padrao: 0 });
  // #endregion

  // #region Refs
  const overlayRef = useRef(null);
  const firstRef = useRef(null);
  // #endregion

  // #region Efeitos
  useEffect(() => {
    if (servico) setForm({ ...servico }); else setForm({ nome: '', categoria: '', descricao: '', preco_padrao: 0, perc_comissao_padrao: 0 });
  }, [servico, open]);

  useEffect(() => { if (open && firstRef.current) firstRef.current.focus(); }, [open]);

  const onKeyDown = useCallback(e => { if (e.key === 'Escape') onClose(); }, [onClose]);
  useEffect(() => { if (!open) return; window.addEventListener('keydown', onKeyDown); return () => window.removeEventListener('keydown', onKeyDown); }, [open, onKeyDown]);
  // #endregion

  // #region Early return
  if (!open) return null;
  // #endregion

  // #region Handlers
  function handleChange(e) {
    const { name, value } = e.target;
    setForm(p => ({ ...p, [name]: value }));
  }

  function submit(e) {
    e.preventDefault();
    if (!form.nome.trim()) {
      alert('Informe o nome do serviço');
      if (firstRef.current) firstRef.current.focus();
      return;
    }
    onSave({
      ...form,
      preco_padrao: Number(form.preco_padrao || 0),
      perc_comissao_padrao: Number(form.perc_comissao_padrao || 0),
    });
    onClose();
  }

  function handleOverlay(e) { if (e.target === overlayRef.current) onClose(); }
  // #endregion

  // #region Render
  return (
    <div className="crud-overlay" ref={overlayRef} onMouseDown={handleOverlay} role="dialog" aria-modal="true">
      <div className="crud-modal" role="document">
        <form onSubmit={submit} className="crud-form">
          <h3>{servico ? 'Editar Serviço' : 'Novo Serviço'}</h3>
          <div className="form-grid">
            <div className="fg-item">
              <label htmlFor="f-nome">Nome *</label>
              <input id="f-nome" name="nome" ref={firstRef} value={form.nome} onChange={handleChange} required />
            </div>
            <div className="fg-item">
              <label htmlFor="f-cat">Categoria</label>
              <input id="f-cat" name="categoria" value={form.categoria} onChange={handleChange} />
            </div>
            <div className="fg-item">
              <label htmlFor="f-preco">Preço Padrão (R$)</label>
              <input id="f-preco" name="preco_padrao" type="number" min="0" step="0.01" value={form.preco_padrao} onChange={handleChange} />
            </div>
            <div className="fg-item">
              <label htmlFor="f-perc">% Comissão</label>
              <input id="f-perc" name="perc_comissao_padrao" type="number" min="0" max="100" step="0.1" value={form.perc_comissao_padrao} onChange={handleChange} />
            </div>
            <div className="fg-item fg-span-2">
              <label htmlFor="f-desc">Descrição</label>
              <textarea id="f-desc" name="descricao" value={form.descricao} onChange={handleChange} />
            </div>
          </div>
          <div className="crud-actions">
            <button type="button" onClick={onClose}>Cancelar</button>
            <button type="submit" className="btn-primary">Salvar</button>
          </div>
        </form>
      </div>
    </div>
  );
  // #endregion
}
